import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SaleIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_882_4757)">
        <path
          d="M7.49984 7.49984H7.50817M12.4998 12.4998H12.5082M13.3332 6.6665L6.6665 13.3332M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984ZM7.9165 7.49984C7.9165 7.72996 7.72996 7.9165 7.49984 7.9165C7.26972 7.9165 7.08317 7.72996 7.08317 7.49984C7.08317 7.26972 7.26972 7.08317 7.49984 7.08317C7.72996 7.08317 7.9165 7.26972 7.9165 7.49984ZM12.9165 12.4998C12.9165 12.73 12.73 12.9165 12.4998 12.9165C12.2697 12.9165 12.0832 12.73 12.0832 12.4998C12.0832 12.2697 12.2697 12.0832 12.4998 12.0832C12.73 12.0832 12.9165 12.2697 12.9165 12.4998Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_882_4757">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default SaleIcon;
